<template>
  <v-card color="brown lighten-4">
    <v-card-title>
      Transactions
      <v-spacer></v-spacer>
      <div>
        <loading-state text="" :state="state"></loading-state>
        <v-btn :disabled="(!valid) || state.isLoading()" class="mr-4" @click="validateAndSave">Filter</v-btn>
      </div>
    </v-card-title>
    <v-card-text  class="white--text" v-if="state.isLoaded()">
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container grid-list-xl fluid>
          <v-layout>
            <v-flex xs6 sm3>
              <v-menu
                ref="startmenu"
                v-model="startdate_model"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filter.start"
                    label="Start Date"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker clearable v-model="filter.start" no-title @change="onStartChange"  @input="startdate_model = false">
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6 sm3>
              <v-menu
                ref="endmenu"
                v-model="enddate_model"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filter.end"
                    label="End Date"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="filter.end" no-title @change="onEndChange"   @input="enddate_model = false">
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6 sm4>
              <v-autocomplete
                v-model="filter.account"
                :loading="accountLoading"
                :items="accounts"
                label="Account"
                clearable
                @keyup.shift.enter="validateAndSave"
                @keyup.ctrl.67="cancelAndNext"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6 sm4>
              <v-autocomplete
                v-model="filter.category"
                :loading="categoryLoading"
                :items="categories"
                ref="catinput"
                label="Category"
                clearable
                @keyup.shift.enter="validateAndSave"
                @keyup.ctrl.67="cancelAndNext"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 sm4>
              <v-autocomplete
                v-model="filter.tags"
                :loading="tagLoading"
                :items="tags"
                multiple
                chips
                small-chips
                deletable-chips
                dense
                label="Tags"
                ref="taginput"
                @keyup.shift.enter="validateAndSave"
                @keyup.ctrl.67="cancelAndNext"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6 sm4>
              <v-autocomplete
                v-model="filter.review_status"
                :items="reviewStatus"
                ref="reviewinput"
                label="Review Status"
                clearable
                @keyup.shift.enter="validateAndSave"
                @keyup.ctrl.67="cancelAndNext"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 sm4>
              <v-switch
                v-model="filter.only_reportable"
                :label="'Only Reportable'"
              ></v-switch>
            </v-flex>

          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from 'moment'
import Utils from "@/utils"
import { DataState } from "@/state"
import { Account } from "@/models/account"
import { Category } from "@/models/category"
import { Tag } from "@/models/tag"
import { TransactionFilter, ReviewStatus } from "@/models/transaction"
export default {
  props: {
    filter: {
      default: ()=>{return TransactionFilter.fromCache()},
      type: Object
    }
  },
  data: () => ({
    dateFormat: 'YYYY-MM-DD',
    state: DataState.newNotInit(),
    accountLoading: false,
    accounts: [],
    categoryLoading: false,
    reviewStatus: ReviewStatus,
    categories: [],
    tagLoading: false,
    tags: [],
    startdate_model: false,
    enddate_model: false,
    valid: true,
    lazy: true
  }),
  mounted () {
    this.onLoaded()
  },
  methods: {
    onLoaded () {
      this.state.changeToLoading()
      this.accountLoading = true
      Account.list().then((response) => {
        this.accounts = response.map((r) => {
          return { text: r.name, value: r.key }
        })
        this.accountLoading = false
        this.categoryLoading = true
        return Category.list()
      }).then((response) => {
        this.categories = response.map((r) => {
          return { text: r.name, value: r.key }
        })
        this.categoryLoading = false
        this.tagLoading = true
        return Tag.list()
      }).then((response) => {
        this.tags = response.map((r) => {
          return { text: r.name, value: r.name }
        })
        this.tagLoading = false
        this.state.changeToLoaded()
      }).catch((error) => {
        console.log('Err', error)
      })
    },

    cancel () {
      this.$emit('input', false)
      this.$emit('canceled', this.transaction, false)
    },

    cancelAndNext () {
      this.$emit('input', false)
      this.$emit('canceled', this.transaction, true)
    },

    validateAndSave () {
      if (this.$refs.form.validate()) {
        this.doFilter()
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    doFilter () {
      this.filter.saveToCache()
      this.$emit('change', this.filter)
    },

    fixDate (onStartSelect) {
      if (this.filter.start && this.filter.end) {
        let startAt = moment(this.filter.start, this.dateFormat)
        let endAt = moment(this.filter.end, this.dateFormat)

        if (startAt > endAt) {
          if (onStartSelect) {
            endAt = startAt.endOf('month')
            this.filter.end = endAt.format(this.dateFormat)
          } else {
            startAt = endAt.startOf('month')
            this.filter.start = startAt.format(this.dateFormat)
          }

        }
      }
    },

    onStartChange () {
      this.fixDate(true)
    },

    onEndChange () {
      this.fixDate(false)
    }

  },
}
</script>